import {request} from '@/plugins/axios'
import qs from 'qs'
//获取今日订单列表
export async function getKhInfo(opt) {
    return await request({
        url: '/api/a_c/userInfo',
        method: 'post',
        data: opt
    })
}

//获取 - 历史订单
export async function historyOrder(opt) {
    return await request({
        url: '/api/a_c/orderList',
        method: 'post',
        data: opt
    })
}


//获取-充值 记录
export async function rechargeRecord(opt) {
    return await request({
        url: '/api/a_c/rechargeRecord',
        method: 'post',
        data: opt
    })
}


//获取--提现记录
export async function cashRecord(opt) {
    return await request({
        url: '/api/a_c/cashRecord',
        method: 'post',
        data: opt
    })
}


//获取--推荐记录
export async function recommendRecord(opt) {
    return await request({
        url: '/api/a_c/recommendRecord',
        method: 'post',
        data: opt
    })
}

//获取额度列表
export async function getEduList(opt) {
    return await request({
        url: '/api/a_c/quotaList',
        method: 'post',
        data: opt
    })
}

//设置授权额度
export async function setEdu(opt) {
    return await request({
        url: '/api/a_c/updateUserQuota',
        method: 'post',
        data: opt
    })

}

//额度添加/修改
export async function setEduAddEdit(opt) {
    return await request({
        url: '/api/a_c/quotaAdd',
        method: 'post',
        data: opt
    })

}


//额度删除

export async function quotaDel(opt) {
    return await request({
        url: '/api/a_c/quotaDel',
        method: 'post',
        data: opt
    })

}


//积分管理
export async function integralManagement(opt) {
    return await request({
        url: '/api/a_c/integralManagement',
        method: 'post',
        data: opt
    })

}

//客户管理全部列表

export async function customerList(opt) {
    return await request({
        url: '/api/a_c/customerList',
        method: 'post',
        data: opt
    })

}

//充值  人民币-美元
export async function recharge(opt) {
    return await request({
        url: '/api/u_i/recharge',
        method: 'post',
        data: opt
    })

}


//增加、减少积分
export async function integralIncrease(opt) {
    return await request({
        url: '/api/a_c/integralIncrease',
        method: 'post',
        data: opt
    })

}

//备注订单信息
export async function remarks(opt) {
    return await request({
        url: '/api/a_c/remarks',
        method: 'post',
        data: opt
    })

}


//邀请记录
export async function invitationRecord(opt) {
    return await request({
        url: '/api/a_c/invitationRecord',
        method: 'post',
        data: opt
    })

}

//邀请记录
export async function invitationAward(opt) {
    return await request({
        url: '/api/a_c/InvitationAward',
        method: 'post',
        data: opt
    })

}



/* //上传水单

export async function uploadFile(opt={}) {
    return await request({
        url: '/api/a_u/upload_file',
        method: 'post',
        data: opt
    })

} */
// 监听是否支付成功

export async function notify(opt) {
    return await request({
        url: '/api/w_p/check',
        method: 'post',
        data: qs.stringify(opt)
    })

}

export async function payIncrease(opt) {
    return await request({
        url: '/api/w_p/payIncrease',
        method: 'post',
        data: qs.stringify(opt)
    })

}

// 汇率
export async function rate(parmas) {
    return await request({
        url: '/api/a_r/rate',
        method: 'post',
        data:qs.stringify(parmas)
    })
}

// 在线支付
export async function line(opt) {
    return await request({
        url: '/api/u_r/line',
        method: 'get',
        params:opt
    })
}

// 在线支付
export async function monitor(parmas) {
    return await request({
        url: '/api/u_r/monitor',
        method: 'post',
        data:qs.stringify(parmas)
    })
}
// 
export async function send_emall(parmas) {
    return await request({
        url: '/api/u_i/inspection',
        method: 'get',
        params:parmas
    })
}

export async function getTuikuanJl(parmas) {
    return await request({
        url: '/api/u_i/refund',
        method: 'post',
        data:qs.stringify(parmas)
    })
}

